<template>
  <div>
    <v-overlay
      v-model="checkingEmailInprogess"
      :opacity="0.8"
      contained
      class="align-center justify-center"
    >
      <v-container>
        <v-row>
          <v-col cols="12" class="d-flex justify-center align-center">
            <div class="h3 white--text mt-10">checking email ...</div>
          </v-col>
          <v-col cols="12" class="d-flex justify-center align-center">
            <v-progress-circular
              indeterminate
              size="80"
              color="white"
              align="center"
              justify="center"
            ></v-progress-circular>
          </v-col>
        </v-row>
      </v-container>
    </v-overlay>
    <v-row v-if="checkingRouteFlag">
      <v-col cols="12">
        <v-alert
          class="alert-box-outline my-2"
          type="error"
          variant="tonal"
          density="compact"
          text
          >Email Id or Succes url is missing in route.</v-alert
        >
      </v-col>
    </v-row>
    <v-row class="mt-10" v-if="showLoginUi">
      <v-col cols="3"></v-col>
      <v-col cols="6">
        <v-card>
          <v-toolbar color="primary" class="white--text" flat>
            <v-toolbar-title text-center>Login</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-alert class="word-break" type="error" v-if="!!errorMessage">{{
              errorMessage
            }}</v-alert>
            <v-alert class="word-break" type="success" v-if="!!signInMessage">{{
              signInMessage
            }}</v-alert>
            <v-form ref="loginForm" id="signin-form" @submit.prevent="signIn">
              <v-text-field
                label="Email Id"
                color="primary"
                density="compact"
                class="textfield-border"
                placeholder="Enter your email id"
                type="email"
                ref="email"
                v-model="email"
                :rules="emailRules"
                :prepend-icon="mdiEmailOutline"
                variant="underlined"
              >
              </v-text-field>

              <v-text-field
                type="password"
                color="primary"
                class="textfield-border"
                label="Password"
                placeholder="Enter your password"
                ref="password"
                density="compact"
                v-model="password"
                :rules="passwordRules"
                :prepend-icon="mdiLock"
                variant="underlined"
              >
              </v-text-field>
              <!-- <v-checkbox v-model="logged" hide-details label="Keep me logged in" color="indigo"></v-checkbox>-->
              <div class="text-right pt-5">
                <v-hover v-slot="{ isHovering, props }">
                  <v-btn
                    :disabled="inProgress"
                    size="large"
                    block
                    v-bind="props"
                    :variant="isHovering ? 'flat' : 'outlined'"
                    :class="
                      isHovering ? 'bg-primary' : ' bg-white text-primary'
                    "
                    class="mt-1 body text-capitalize"
                    type="submit"
                    form="signin-form"
                    rounded="0"
                    @click="signIn"
                    ><v-progress-circular
                      :size="20"
                      :color="isHovering ? 'primary' : 'primary'"
                      indeterminate
                      v-if="inProgress"
                    ></v-progress-circular>
                    Login</v-btn
                  >
                </v-hover>
              </div>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="mt-10" v-if="showSignUpUi">
      <v-col cols="3"></v-col>
      <v-col cols="6">
        <v-card class="mx-auto my-auto" elevation="10">
          <v-toolbar color="primary" class="white--text" flat>
            <v-toolbar-title>Signup</v-toolbar-title>
          </v-toolbar>
          <v-card-text class="pt-6">
            <v-alert type="error" v-if="!!signUpError">{{
              signUpError
            }}</v-alert>
            <v-alert type="success" v-if="!!signUpMessage">{{
              signUpMessage
            }}</v-alert>
            <v-form ref="signUpForm" id="signup-form" @submit.prevent="signUp">
              <v-text-field
                label="First Name"
                class="textfield-border"
                type="text"
                density="compact"
                ref="firstName"
                placeholder="Enter your First Name"
                v-model="firstname"
                variant="underlined"
                :rules="firstNameRules"
                color="primary"
                :prepend-icon="mdiAccount"
              ></v-text-field>
              <v-text-field
                label="Last Name"
                class="textfield-border"
                type="text"
                density="compact"
                ref="lastName"
                placeholder="Enter your Last Name"
                v-model="lastname"
                variant="underlined"
                :rules="lastNameRules"
                color="primary"
                :prepend-icon="mdiAccount"
              ></v-text-field>

              <v-text-field
                label="Email Id"
                class="textfield-border"
                placeholder="Enter your email"
                type="email"
                density="compact"
                ref="email"
                id="userEmail"
                v-model="signUpemail"
                variant="underlined"
                :rules="emailRules"
                color="primary"
                :prepend-icon="mdiEmailOutline"
              ></v-text-field>

              <v-text-field
                type="password"
                class="textfield-border"
                label="Password"
                density="compact"
                ref="password"
                variant="underlined"
                placeholder="Enter your password"
                v-model="signUpPassword"
                color="primary"
                :rules="commonValidationRules.passwordRule"
                :prepend-icon="mdiLock"
              ></v-text-field>
              <v-checkbox
                v-model="newsletter"
                hide-details="auto"
                label="Subscribe to our newsletter"
                color="indigo"
              ></v-checkbox>
              <div class="text-right mt-7">
                <v-hover v-slot="{ isHovering, props }">
                  <v-btn
                    size="large"
                    block
                    v-bind="props"
                    :variant="isHovering ? '' : 'outlined'"
                    :class="
                      isHovering
                        ? 'bg-primary text-white '
                        : 'bg-white text-primary'
                    "
                    :disabled="signUpInProgress"
                    class="mt-1 body fontsize-14 text-capitalize"
                    tile
                    rounded="0"
                    type="submit"
                    form="signup-form"
                    @click="signUp"
                  >
                    <v-progress-circular
                      :size="20"
                      color="primary"
                      indeterminate
                      v-if="signUpInProgress"
                    ></v-progress-circular
                    >Signup
                  </v-btn>
                </v-hover>
              </div>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <SnackbarComponent :snackbar="snackbar"></SnackbarComponent>
  </div>
</template>
<script>
import SnackbarComponent from "@/components/common/SnackbarComponent.vue";
import { createHelpers } from "vuex-map-fields";
import { mdiAccount, mdiEmailOutline, mdiLock } from "@mdi/js";
import { commonValidationRules } from "@/services/util.service";
const { mapFields: mapFieldsAuth } = createHelpers({
  getterType: "auth/getField",
  mutationType: "auth/updateField",
});
const { mapFields: registerInfo } = createHelpers({
  getterType: "registration/getField",
  mutationType: "registration/updateField",
});
export default {
  name: "mlinkPage",
  components: { SnackbarComponent },
  data: () => ({
    checkingRouteFlag: false,
    checkingEmailInprogess: false,
    base64EncodingFlag: true,
    decodeEmail: null,
    successUrl: null,
    snackbar: {
      show: false,
      message: null,
      color: null,
      timeout: 0,
    },
    emailRules: [
      (v) => !!v || "Email is required",
      (v) => /.+@.+\..+/.test(v) || "Email must be valid",
    ],
    passwordRules: [
      (v) => !!v || "Password is required",
      (v) => (v && v.length >= 8) || "Password must be at least 8 characters",
    ],
    firstNameRules: [
      (v) => !!v || "First Name is required",
      (v) => (v && v.length >= 3) || "First Name must be at least 3 characters",
    ],
    lastNameRules: [
      (v) => !!v || "Last Name is required",
      (v) => (v && v.length >= 3) || "Last Name must be at least 3 characters",
    ],
    mdiEmailOutline,
    mdiLock,
    mdiAccount,
    showLoginUi: false,
    showSignUpUi: false,
    commonValidationRules: commonValidationRules,
  }),
  computed: {
    ...mapFieldsAuth([
      "one.email",
      "one.password",
      "errorMessage",
      "inProgress",
      "signInMessage",
    ]),
    ...registerInfo({
      firstname: "one.firstname",
      lastname: "one.lastname",
      newsletter: "one.newsletter",
      signUpemail: "one.email",
      signUpPassword: "one.password",
      signUpMessage: "signUpMessage",
      signUpError: "errorMessage",
      signUpInProgress: "inProgress",
    }),
    base64Encoding: function () {
      return this.$route.params.base64Encoding;
    },
  },
  methods: {
    async isEmailAvailableFun(email) {
      this.showLoginUi = false;
      this.showSignUpUi = false;
      this.checkingEmailInprogess = true;
      try {
        let data = await this.$store.dispatch(
          "guestInfo/checkEmailAvailable",
          email
        );
        if (data.exist == false) {
          this.checkingEmailInprogess = false;
          this.showLoginUi = true;
        } else {
          this.checkingEmailInprogess = false;
          this.showSignUpUi = true;
        }
      } catch (error) {
        this.snackbar = {
          message: error,
          color: "error",
          show: true,
          timeout: 2000,
        };
        this.checkingEmailInprogess = false;
      }
    },

    async signIn() {
      try {
        let validate = await this.$refs.loginForm.validate();
        if (validate && validate.valid) {
          this.$store.dispatch("auth/changeRedirectFlag", false);
          let status = await this.$store.dispatch("auth/login");
          if (status) {
            this.$store.dispatch("auth/changeRedirectFlag", true);
            // this.$store.dispatch("accountOne/basicInfo");
            //  this.$store.dispatch("userCartProduct/cartProductList");
            window.open(this.successUrl, "_self");
          }
        }
      } catch (error) {
        this.snackbar = {
          message: error,
          color: "error",
          show: true,
          timeout: 2000,
        };
      }
    },
    async signUp(e) {
      try {
        e.preventDefault();
        let validate = await this.$refs.signUpForm.validate();
        if (validate && validate.valid) {
          this.$store.dispatch("auth/changeRedirectFlag", false);
          let status = await this.$store.dispatch("registration/signUp");

          if (status && status.registration) {
            this.$store.dispatch("auth/changeRedirectFlag", false);
            window.open(this.successUrl, "_self");
          }
        }
      } catch (error) {
        this.snackbar = {
          message: error,
          color: "error",
          show: true,
          timeout: 2000,
        };
      }
    },
  },
  created() {
    try {
      this.checkingEmailInprogess = true;
      if (this.base64Encoding) {
        const base64Encoding = atob(this.base64Encoding);
        this.checkingRouteFlag = false;
        const fixed = base64Encoding.replace(/([{,])\s*(\w+)\s*:/g, '$1"$2":');
        const obj = JSON.parse(fixed);

        if (obj && obj.email && obj.success_url) {
          this.decodeEmail = obj.email;
          this.successUrl = obj.success_url;
          this.isEmailAvailableFun(this.decodeEmail);
        } else {
          this.checkingRouteFlag = true;
          this.checkingEmailInprogess = false;
        }
      }
    } catch (err) {
      this.checkingEmailInprogess = false;
      this.snackbar = {
        message: err,
        color: "error",
        show: true,
        timeout: 2000,
      };
    }
  },
};
</script>
